import { Button } from '../../components/ui/button';
import { Trash2, X, FolderInput } from 'lucide-react';

export function BulkActionBar({ selectedCount, onClear, onMove, onDelete }) {
  if (selectedCount === 0) return null;
  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 bg-background border shadow-2xl rounded-full px-2 py-2 flex items-center gap-2 animate-in fade-in slide-in-from-bottom-4"
      data-testid="bulk-action-bar"
    >
      <span className="px-3 text-sm font-medium" data-testid="bulk-selection-count">
        {selectedCount} selected
      </span>
      <Button size="sm" variant="ghost" onClick={onClear} data-testid="bulk-clear-btn">
        <X className="w-4 h-4 mr-1" />Clear
      </Button>
      <Button size="sm" variant="outline" onClick={onMove} data-testid="bulk-move-btn">
        <FolderInput className="w-4 h-4 mr-2" />Move to folder
      </Button>
      <Button size="sm" variant="destructive" onClick={onDelete} data-testid="bulk-delete-btn">
        <Trash2 className="w-4 h-4 mr-2" />Delete {selectedCount}
      </Button>
    </div>
  );
}
